import { isRequired } from '@shared/utils/CustomErrors'

import config from '@shared/config'

import useBackend from '@shared/hooks/useBackend'

function documentUpload() {
  // HOOKS
  const { buildURL, doGet, doDelete, doPost, setup } = useBackend()

  // INIT
  setup('/ovpv3/public', config.microserviceBaseUrl)

  // METHODS
  function deleteDocument({
    basketId = isRequired('basketId'),
    personId = isRequired('personId'),
    documentId = isRequired('documentId'),
  }) {
    return doDelete({
      url: `/baskets/${basketId}/persons/${personId}/documents/${documentId}`,
    })
  }

  async function getDocument({
    basketId = isRequired('basketId'),
    personId = isRequired('personId'),
    documentId = isRequired('documentId'),
  }) {
    const response = await doGet({
      url: `/baskets/${basketId}/persons/${personId}/documents/${documentId}`,
      options: { responseType: 'blob' },
    })

    window.open(URL.createObjectURL(response))
  }

  async function getDocuments({ basketId = isRequired('basketId'), personId = isRequired('personId') }) {
    const response = await doGet({
      url: `/baskets/${basketId}/persons/${personId}/documents`,
    })

    return response.data
  }

  async function uploadDocument({
    basketId = isRequired('basketId'),
    personId = isRequired('personId'),
    type = isRequired('type'),
    file = isRequired('file'),
  }) {
    const formData = new FormData()
    formData.append('documentFile', file, file.name.replace('=', '_'))

    const response = await doPost({
      url: buildURL(`/baskets/${basketId}/persons/${personId}/documents`, { documentType: type }),
      data: formData,
      config: {
        headers: {
          'Content-Type': 'multipart/form-data',
        },
      },
    })
    return response.data
  }

  return {
    deleteDocument,
    getDocument,
    getDocuments,
    uploadDocument,
  }
}

export default documentUpload()
